import {AddressFormKyc} from '@/dataSource/src/api/kyc/useRepository';

export const normalizePersistedAddress = (
  value: Partial<AddressFormKyc> | null,
): AddressFormKyc | null => {
  if (!value) {
    return null;
  }

  return {
    addressLineShortened:
      value.addressLineShortened || value.addressLine1 || '',
    addressLine1: value.addressLine1 || value.addressLineShortened || '',
    addressLine2: value.addressLine2 || '',
    city: value.city || '',
    state: value.state || value.region || '',
    zipCode: value.zipCode || '',
    region: value.region || value.state || '',
  };
};

export const isValidPersistedAddress = (
  value: AddressFormKyc | null,
): value is AddressFormKyc => {
  if (!value) {
    return false;
  }

  return !!(
    value.addressLineShortened &&
    value.city &&
    value.zipCode &&
    (value.region || value.state)
  );
};
